
import { CHANGE_PASSWORD, FORGETPASSWORD, LOGIN, REGISTER, RESENDOTP, RESETPASSWORD, VERIFYOTP } from "../Constants/AuthContants";
import { createGetDataReducer } from "./CommonReducer";

const UserRegisterReducer = createGetDataReducer(REGISTER);
const VerifyOtpReducer = createGetDataReducer(VERIFYOTP);
const UserLoginReducer = createGetDataReducer(LOGIN);
const ForgetPasswordReducer = createGetDataReducer(FORGETPASSWORD);
const ResetPasswordReducer = createGetDataReducer(RESETPASSWORD);
const ResendOtpReducer = createGetDataReducer(RESENDOTP);
const ChangePasswordReducer = createGetDataReducer(CHANGE_PASSWORD);

export const AuthReducers = {
    UserRegisterState: UserRegisterReducer,
    VerifyOtpState: VerifyOtpReducer,
    UserLoginState: UserLoginReducer,
    ForgetPasswordState: ForgetPasswordReducer,
    ResetPasswordState: ResetPasswordReducer,
    ResendOtpState: ResendOtpReducer,
    ChangePasswordState: ChangePasswordReducer
}